import React from 'react';
import style from 'styles/about/contact.module.scss';
import Wrap from 'components/about/wrap';
const office = [
  {
    name: '上海办事处',
    address: '上海市徐汇区宜山路717号2号楼903室',
  },
  {
    name: '广州办事处',
    address: '广州市天河区东莞庄路中创盈科赛宝科技园1栋7楼707',
  },
  {
    name: '成都办事处',
    address: '成都市武侯区人民南路四段3号成都来福士办公楼 T2-29-01B',
  },
  {
    name: '武汉办事处',
    address: '武汉市东湖高新技术开发区雄庄路8号曙光星城D区光谷APP广场4号楼6层',
  },
  {
    name: '济南办事处',
    address: '济南市高新区万达广场J1号楼1单元17层1712室',
  },
  {
    name: '西安办事处',
    address: '西安市莲湖区唐延路北段20号太和时代广场D座办公楼12层1201室',
  },
  {
    name: '郑州办事处',
    address: '郑州市金水区黄河路11号豫粮大厦16层',
  },
  {
    name: '深圳办事处',
    address: '深圳市龙岗区坂田雅宝路星河领创天下1期407室',
  },
  {
    name: '南京办事处',
    address: '南京市江宁区金兰路11号212室',
  },
  {
    name: '石家庄办事处',
    address: '石家庄市长安区谈南路63号睿和中心1004室',
  },
  {
    name: '呼和浩特办事处',
    address: '呼和浩特市赛罕区赛罕区政府广场西侧风华家园5号楼三层2区',
  },
];
const Contact = () => {
  return (
    <Wrap title="联系我们" pageKey="contact">
      <div className={style.container}>
        <div className={style.contact}>
          <p className={style.title}>联系方式</p>
          <p className={style.contactInfo}>
            总部地址 : 北京市东城区北三环东路36号环球贸易中心A座25层
            <br />
            联系电话 : 400-900-3567
            <br />
            市场合作 : mkt@xylink.com
            <br />
            购买咨询 : sales@xylink.com
            <br />
            举报电话 : 400-900-3567
            <br />
            举报邮箱 : jubao@xylink.com
            <br />
            客服邮箱 : support@xylink.com
            <br />
          </p>
        </div>
        <div className={style.officeSection}>
          <div className={style.title}>销售办事处</div>
          <div className={style.row}>
            {office.map(item => {
              return (
                <div key={item.name} className={style.column}>
                  <div className={style.office}>{item.name}</div>
                  <div className={style.address}>地址 : {item.address}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Wrap>
  );
};

export default Contact;
